import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

/** Mensagem de lista vazia com ícone, descrição e ação opcionais. */
export function EmptyState({
  title,
  description,
  action,
  icon: Icon,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: LucideIcon;
}): ReactNode {
  return (
    <div role="status" className="flex flex-col items-center gap-2 py-4 text-center">
      {Icon && <Icon aria-hidden className="size-8 text-muted-foreground" />}
      <p className="font-medium">{title}</p>
      {description && <p className="text-sm text-muted-foreground">{description}</p>}
      {action}
    </div>
  );
}
